export default __webpack_public_path__ + "media/src/images/assign_route/in_transit-7c5f47e5200e9f5e71dfd3bb143ef71d.svg";